import Masonry from '../../../node_modules/masonry-layout/dist/masonry.pkgd.js';
import imagesLoaded from '../../../node_modules/imagesloaded/imagesloaded.pkgd.js';
import { Fancybox } from "@fancyapps/ui";

// imagesLoaded( document.querySelectorAll('.masonry-grid'), function( instance ) {
    var elems = document.querySelectorAll('.masonry-grid');

    for (var i = elems.length - 1; i >= 0; i--) {
        var msnry = new Masonry( elems[i], {
            // options
            itemSelector: '.masonry-grid-item',
            percentPosition: true,
            gutter: 0,
        });

        msnry.once( "layoutComplete", function(){
            console.log('msnry layoutComplete once:');
            msnry.layout();
        });

        imagesLoaded( elems, function( instance ) {
           console.log('all images are loaded 2.0: ', instance);
           msnry.layout();
        });
    };
// });
